import React, { useEffect } from "react";
import ConfiguratorApp from "components/ConfiguratorApp";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
const ConfiguratorAppPage = () => {
  const user = useSelector((state) => state.auth.user);
  const history = useHistory();
  useEffect(() => {
    if (user?.userGroup?.name !== "configurator") {
      history.push("/");
    }
  }, [user]);
  return (
    <div>
      <ConfiguratorApp />
    </div>
  );
};

export default ConfiguratorAppPage;
